import { AppBar } from "react-admin";

const CustomAppBar = (props) => {
  return (
    <AppBar {...props} className="bg-primary" color="primary" userMenu={true} >
      <div style={{ flex: 1 }}></div>
      <div className="absolute w-screen flex justify-center items-center -z-50">
        <p>محصول</p>
      </div>
      <div style={{ flex: 1 }}></div>
    </AppBar>
  );
};

export default CustomAppBar;
